import { Button, Icon, PopoverBody, PopoverContent, PopoverHeader, PopoverTrigger } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { ElementType, ReactNode } from 'react';
import { HiChevronDown } from 'react-icons/hi';

type Props = {
  label: string;
  icon?: ElementType;
  isSelected?: boolean;
};

export const FilterPopoverButton = ({ label, icon, isSelected }: Props) => (
  <PopoverTrigger>
    <Button
      bgColor="bg.surface"
      borderColor={isSelected ? 'border.focused' : 'border.light'}
      borderWidth="1px"
      borderRadius="lg"
      _hover={{
        borderColor: 'border.hover',
        bgColor: 'bg.surface',
      }}
      _active={{
        borderColor: 'border.focused',
        bgColor: 'bg.surface',
      }}
      leftIcon={icon ? <Icon as={icon} /> : null}
      rightIcon={<HiChevronDown />}
    >
      {label}
    </Button>
  </PopoverTrigger>
);

type FilterPopoverContentProps = {
  header?: string;
  children?: ReactNode;
};

export const FilterPopoverContent = ({ header, children }: FilterPopoverContentProps) => (
  <PopoverContent
    _focus={{ shadow: 'none', outline: 0 }}
    _focusVisible={{ shadow: 'outline' }}
    maxH="300px"
    overflowY="auto"
  >
    <Show if={!!header}>
      <PopoverHeader srOnly>{header}</PopoverHeader>
    </Show>
    <PopoverBody px="3" py="1.5">
      {children}
    </PopoverBody>
  </PopoverContent>
);
